<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">
        <div class="form-group row">
          <reg-input-text
            v-if="fields[0]"
            label="Street Address"
            :form="form"
            :field="fields[0]"
            placeholder="Enter Street Address"
            :api-errors="apiErrors"
            formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4"
            :rules="{ required: fields[0].required }"
          />
          <reg-input-text
            v-if="fields[1]"
            label="Apt/Suite/Other"
            :form="form"
            :field="fields[1]"
            placeholder="Enter Apt/Suite/Other"
            :api-errors="apiErrors"
            formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4"
            :rules="{ required: fields[1].required }"
          />
        </div>
        <div class="form-group row">
          <reg-input-text
            v-if="fields[2]"
            label="City"
            :form="form"
            :field="fields[2]"
            placeholder="Enter City"
            :api-errors="apiErrors"
            formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4"
            :rules="{ required: fields[2].required }"
          />
          <reg-input-text
            v-if="fields[3]"
            label="State"
            :form="form"
            :field="{ ...fields[3], readOnly: true }" 
            placeholder="Choose a State"
            :api-errors="apiErrors"
            formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4"
            :rules="{ required: fields[3].required }"
          />
        </div>
        <div class="form-group row">
          <reg-input-text
            v-if="fields[4]"
            type="number"
            label="Zip Code"
            :form="form"
            :field="fields[4]"
            placeholder="Enter Zip Code"
            :api-errors="apiErrors"
            formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4"
            :rules="{ required: fields[4].required, digits: 5 }"
             @keypress.native="onlyAllowDigits($event)"
             @input.native="autoFillState"
             maxlength="5"
             inputmode="numeric"
             pattern="\d*"
          />
        </div>
        <div class="form-group">
          <div class="mb-4 form-check">
            <input
              class="form-check-input"
              v-if="fields[5] && fields[5].field_name"
              type="checkbox"
              id="flexCheckDefault"
              :class="apiErrors && apiErrors[fields[5].field_name] ? 'error-input' : ''"
              :disabled="fields[5] && fields[5].readOnly"
              v-model="form[fields[5].field_name]"
            />
            <label class="form-check-label" for="flexCheckDefault">Validate with USPS</label>
            <error-text
              v-if="apiErrors && apiErrors[fields[5].field_name]"
              :errors="apiErrors"
              :field="fields[5].field_name"
            />
          </div>
        </div>
        <div class="action-btn split-action mt-5">
          <button class="button-black" @click="backHandler" type="button">Back</button>
          <div class="action-next">
            <button class="button-green" @click.prevent="saveAndContinue" type="button">
              Save & Continue Later
            </button>
            <button class="button-blue" type="submit">Next</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
  import axios from '@/utils/regAxios';
  import Screenshot from '@/utils/screenshot';

  export default {
    name: 'AddressForm',
    props: {
      fields: {
        required: true,
      },
      form: {
        required: true,
      },
      states: {
        required: true,
      },
    },
    data: () => ({
      apiErrors: null,
    }),
    methods: {
       disableStateInput() {
      const stateInput = document.querySelector('#' + this.fields[3].field_name);
      if (stateInput) stateInput.disabled = true;
    },
    onlyAllowDigits(event) {
  const key = event.key;
  // Allow: backspace, delete, tab, escape, enter, arrows, home, end
  if (
    [46, 8, 9, 27, 13, 37, 38, 39, 40, 35, 36].includes(event.keyCode) ||
    // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    (event.ctrlKey === true && [65, 67, 86, 88].includes(event.keyCode))
  ) {
    return;
  }
  // Ensure it's a number and not more than 9 digits
  if (!/^\d$/.test(key) || event.target.value.length >= 5) {
    event.preventDefault();
  }
},
async autoFillState(event) {
  let inputValue = event.target.value;

  if (inputValue.length > 5) {
    inputValue = inputValue.slice(0, 5);
    this.form['zip'] = inputValue;
  }
  this.form['zip'] = inputValue;

  if (inputValue.length === 5) {
    try {
      const url = process.env.VUE_APP_VALIDATE_ZIP;  
      console.log('Making POST request to:', url);

      const res = await axios.post(url, { zip: inputValue });
      console.log('ZIP API response:', res.data);

      if (res.data.status === 'success' && res.data.data && res.data.data[0]) {
        this.form.state = res.data.data[0].state_abbreviation || null;
      }
    } catch (err) {
      console.error('ZIP validation failed:', err.response?.data || err);
      this.$notify('Invalid Zip Code', 'error');
    }
  }
},
      setUspsValue() {
        if (this.fields && this.fields[5]) {
          let fieldName = this.fields[5].field_name;
          this.form[fieldName] =
            this.form[fieldName] === 'true' || this.form[fieldName] == true ? true : false;
        }
      },
      saveAndContinue() {
        this.$emit('onOpenSaveAndContinue', this.form);
      },
      backHandler() {
        this.$emit('onBackHandler');
      },
      async submit() {
        this.form.registration_id = this.$store.getters.regTempId;
        let loader = this.$loading.show();
        this.form[this.fields[5].field_name] =
          this.form[this.fields[5].field_name] === 'true' ||
          this.form[this.fields[5].field_name] == true
            ? true
            : false;
        let formData = this.form;
        Screenshot.captureScreenShot(Screenshot.regScreenShotSelector)
          .then((res) => {
            if (res) {
              formData['screenshot'] = res;
            }
          })
          .finally(() => {
            loader.hide();
            const url = 'register/address-info';
            this.save(url, formData);
          });
      },
      async save(url, payload) {
        let loader = this.$loading.show();
        try {
          let res = await axios.post('register/address-info', this.form);
          if (res.data.statusCode == 200) {
            this.$emit('onSuccess');
          }
        } catch (err) {
          if (err.response.data.statusCode == 422) {
            this.apiErrors = err.response.data.errors;
            setTimeout(() => {
              this.apiErrors = null;
            }, 5000);
          } else {
            this.$notify(err.response.data.message, 'Error', 'error');
          }
        } finally {
          loader.hide();
        }
      },
    },
    created() {
      if (!this.$store.getters.regTempId) {
        this.backHandler();
      }
      if (this.fields[5] && this.fields[5].field_name) {
      this.form[this.fields[5].field_name] = true;
    }
    },
    mounted() {
    this.disableStateInput();
  },
  };
</script>
